import api, { getPaginatedList } from 'shared/api'

export const doLoad = async props => {
  return await getPaginatedList('/admin/users', props)
}

export const doUpdatePhysicianStatus = async props => {
  return await api.put(`/admin/users/${props?.id}/verify-physician`)
}
